import {
  PagamentoWithDettaglioDTO,
  PagamentoWithDettaglioDTOModelloPagamentoSelezionato,
} from '@framework/api-client';

/**
 * Indica se il metodo di pagamento è bloccato su un metodo di pagamento
 * *DIFFERENTE* da quello specificato.
 */
export function isPaymentLockedToDifferentMethod(
  payment: PagamentoWithDettaglioDTO,
  method: PagamentoWithDettaglioDTOModelloPagamentoSelezionato,
) {
  return (
    payment.modelloPagamentoSelezionato != null &&
    payment.modelloPagamentoSelezionato !== method
  );
}
